import './arkConfig.ts';
import { isDefined } from '@sgme/fp';
import { type } from 'arktype';

import { logger } from '@/components/SgwtBootstrap/logger.ts';
import { type WorkspaceForex, WorkspaceValidator } from '@/domain/WorkspaceForex/WorkspaceForex.ts';

export function validateWorkspace(workspace: unknown): WorkspaceForex | undefined {
  const result = WorkspaceValidator(workspace);
  if (result instanceof type.errors) {
    logger.logError('Invalid workspace data: {errors_s}', result.toString());
    return undefined;
  }
  // Ensure that option have one default leg
  if (isDefined(result.products.option)) {
    for (const option of result.products.option) {
      if (option.properties.legs.length === 0) {
        option.properties.legs.push({ legId: `${option.tileId}/0`, legProductName: 'Vanilla' });
      }
    }
  }
  return result;
}
